import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import { ChartAnchoredTooltip, ChartTooltip } from '../../../Chart'

import { getBirdviewAgingChartTooltipRows } from './BirdviewAgingChartTooltip.utils'

function BirdviewAgingChartTooltip({
  active,
  label,
  payload = EMPTY_LIST,
  total,
}) {
  const { t } = useTranslation()

  const bucket = payload[0]

  return active && bucket ? (
    <ChartAnchoredTooltip isInsidePlot>
      <ChartTooltip
        rows={getBirdviewAgingChartTooltipRows({ bucket, label, t, total })}
        title={label}
      />
    </ChartAnchoredTooltip>
  ) : null
}

export default BirdviewAgingChartTooltip
